<template>
  <v-sheet tag="section" :class="(this.$route.name.match(/PickupPackages/))? $vuetify.breakpoint.smAndDown? 'mb-8' : 'mb-15': ''">
    <v-row v-if="(!hideTitle && this.$route.name.match(/PickupPackages/))" class="form-item-heading" :class="headingBgColor">
      <v-subheader class="text-subtitle-1 align-center"
                   :class="[headingTextColor ? `${headingTextColor}--text` : null, headingPadding, {'font-weight-bold': isHeadingTextBold}]">
        集荷箱数・集荷日時
      </v-subheader>
    </v-row>
    <vb-form-row item-name="箱数">
      <template #input>
        {{ formItems.numberOfPackages }} 箱
        <p v-if="!isCharibon" class="my-0 error--text">（{{ (buyFormLabels.isShippingFree || buyFormLabels.isShippingFreeAutoApplication) ? "送料無料" : "送料　" + shippingCostCalculation + "円" }}）</p>
      </template>
    </vb-form-row>

    <vb-form-row item-name="集荷希望日時">
      <template #input>
        {{ ($route.path === routeResolve('PickupPackagesReference'))
          ? buyStateFormLabels.pickupDate
          : formattedPickupDate }}
        {{ ($route.path === routeResolve('PickupPackagesReference'))
          ? buyStateFormLabels.pickupPeriodName
          : buyFormLabels.pickupPeriodName }}
      </template>
    </vb-form-row>
  </v-sheet>
</template>

<script>
import {mapGetters} from 'vuex';
import VbFormRow from "../../molecules/buy/vb-form-row.vue";

export default {
  name: "pickup-packages-confirm",
  components: {VbFormRow},
  props: {
    headingBgColor: {type: String, default: null},
    headingTextColor: {type: String, default: null},
    headingPadding: {type: String, default: null},
    isHeadingTextBold: {type: Boolean, default: false},
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      getBuyFormItems: 'buy/getFormItems',
      getBuyFormLabels: 'buy/getFormLabels',
      getBuyStateFormLabels: 'buyState/getFormLabels',
    }),
    isCharibon() {
      return this.$siteCode === VueConfig.siteCode.charibon;
    },
    buyFormItems() {
      return this.getBuyFormItems;
    },
    buyFormLabels() {
      return this.getBuyFormLabels;
    },
    buyStateFormLabels() {
      return this.getBuyStateFormLabels;
    },
    formItems() {
      if (this.$route.path === this.routeResolve('PickupPackagesReference')){
        // 参照画面用
        return this.getBuyStateFormLabels;
      } else {
        // 入力確認画面用
        return this.getBuyFormItems;
      }
    },
    formattedPickupDate() {
      return (new Date(this.buyFormItems.pickupDate)).toLocaleDateString('ja-JP', {
        weekday: 'short',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    shippingCostCalculation() {
      return this.formItems.numberOfPackages * VueConfig.sell.shippingFeePerPackage;
    },
  },
  methods: {
    routeResolve(name) {
      const route = this.$router.resolve({
        name: name,
      }).href
      if(this.$routerBase){
        const reg = new RegExp("^" + this.$routerBase);
        const url = route.replace(reg, "")
        return '/' + url
      } else {
        return route
      }
    },
  }
}
</script>

<style scoped lang="scss">
.specify-border {
    position: relative;
    &:after {
        content: "";
        display: block;
        border-top: 1px solid #FBFAF5;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
}
</style>